import { useState } from 'react';

function FAQ3() {
  const [openIndex, setOpenIndex] = useState(0); // First question is open by default

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white py-12 sm:py-16 px-4 sm:px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-start">
          {/* Left Side - Content - Mobile: Second, Desktop: Left */}
          <div className="order-2 lg:order-1">
            {/* Mobile: Show image first */}
            <div className="w-full mb-6 lg:hidden">
              <img 
                src="https://empirelimotransfer.com/wp-content/uploads/elementor/thumbs/Quality-and-Comfort-in-Black-Car-Services-rfbp7tg55qeyb9siklds8nx4852mhwtastvj8qkxq0.png" 
                alt="Quality and Comfort in Black Car Services" 
                className="w-full h-64 sm:h-80 object-cover rounded-lg shadow-lg"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="w-full h-64 sm:h-80 bg-gradient-to-br from-gray-200 to-gray-300 rounded-lg flex items-center justify-center"><span class="text-6xl">🚗</span></div>';
                }}
              />
            </div>
            
            <div className="flex items-center mb-4">
              <h3 className="text-lg sm:text-xl font-semibold">Cruise Terminal Transportation FAQs</h3>
            </div>
            
            {/* Customer Testimonials Section */}
            <div className="mb-6 sm:mb-8">
              <h3 className="text-lg sm:text-xl font-semibold text-black mb-4">
                Why Choose Our Cruise Terminal Service
              </h3>

              <p className="text-gray-900 leading-relaxed text-sm sm:text-base mb-3">
                • Fixed pricing with no surprise fees
              </p>
              <p className="text-gray-900 leading-relaxed text-sm sm:text-base mb-3">
                • Professional, licensed chauffeurs
              </p>
              <p className="text-gray-900 leading-relaxed text-sm sm:text-base mb-3">
                • Ample luggage space for cruise gear
              </p>
              <p className="text-gray-900 leading-relaxed text-sm sm:text-base mb-3">
                • Punctual service with flight tracking
              </p>
              <p className="text-gray-900 leading-relaxed text-sm sm:text-base">
                • 24/7 customer support
              </p>
            </div>
            
            
            
            {/* Desktop: Show image after text */}
            <div className="w-full hidden lg:block">
              <img 
                src="https://empirelimotransfer.com/wp-content/uploads/elementor/thumbs/Quality-and-Comfort-in-Black-Car-Services-rfbp7tg55qeyb9siklds8nx4852mhwtastvj8qkxq0.png" 
                alt="Quality and Comfort in Black Car Services" 
                className="w-full h-64 sm:h-80 lg:h-[320px] object-cover rounded-lg shadow-lg"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="w-full h-64 sm:h-80 lg:h-[280px] bg-gradient-to-br from-gray-200 to-gray-300 rounded-lg flex items-center justify-center"><span class="text-6xl">🚗</span></div>';
                }}
              />
            </div>
          </div>

          {/* Right Side - FAQ Accordion - Mobile: First, Desktop: Right */}
          <div className="space-y-4 order-1 lg:order-2">
            {/* FAQ 1 */}
            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleFAQ(0)}
                className={`w-full px-4 sm:px-6 py-3 sm:py-4 text-left flex justify-between items-center transition-colors ${
                  openIndex === 0 
                    ? 'bg-black text-white' 
                    : 'bg-gray-50 text-gray-900 hover:bg-gray-100'
                }`}
              >
                <span className="font-semibold pr-4 text-sm sm:text-base">What is cruise terminal transportation?</span>
                <span className="flex-shrink-0">
                  {openIndex === 0 ? (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                  ) : (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  )}
                </span>
              </button>
              {openIndex === 0 && (
                <div className="px-4 sm:px-6 py-3 sm:py-4 bg-white border-t border-gray-200">
                  <p className="text-gray-900 leading-relaxed text-sm sm:text-base">
                    Cruise terminal transportation is a private car or limo service that provides reliable transfers to and from cruise ports.
                  </p>
                </div>
              )}
            </div>

            {/* FAQ 2 */}
            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleFAQ(1)}
                className={`w-full px-4 sm:px-6 py-3 sm:py-4 text-left flex justify-between items-center transition-colors ${
                  openIndex === 1 
                    ? 'bg-black text-white' 
                    : 'bg-gray-50 text-gray-900 hover:bg-gray-100'
                }`}
              >
                <span className="font-semibold pr-4 text-sm sm:text-base">How early should I arrive at a New York cruise port?</span>
                <span className="flex-shrink-0">
                  {openIndex === 1 ? (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                  ) : (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  )}
                </span>
              </button>
              {openIndex === 1 && (
                <div className="px-4 sm:px-6 py-3 sm:py-4 bg-white border-t border-gray-200">
                  <p className="text-gray-900 leading-relaxed text-sm sm:text-base">
                    Most cruise lines recommend arriving 2–3 hours before departure. Our chauffeurs plan pickups accordingly.
                  </p>
                </div>
              )}
            </div>

            {/* FAQ 3 */}
            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleFAQ(2)}
                className={`w-full px-4 sm:px-6 py-3 sm:py-4 text-left flex justify-between items-center transition-colors ${
                  openIndex === 2 
                    ? 'bg-black text-white' 
                    : 'bg-gray-50 text-gray-900 hover:bg-gray-100'
                }`}
              >
                <span className="font-semibold pr-4 text-sm sm:text-base">Is a limo service better than a taxi for cruise ports?</span>
                <span className="flex-shrink-0">
                  {openIndex === 2 ? (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                  ) : (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  )}
                </span>
              </button>
              {openIndex === 2 && (
                <div className="px-4 sm:px-6 py-3 sm:py-4 bg-white border-t border-gray-200">
                  <p className="text-gray-900 leading-relaxed text-sm sm:text-base">
                    Yes. A cruise terminal limo service offers fixed pricing, guaranteed availability, professional drivers, and ample luggage space.
                  </p>
                </div>
              )}
            </div>

            {/* FAQ 4 */}
            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleFAQ(3)}
                className={`w-full px-4 sm:px-6 py-3 sm:py-4 text-left flex justify-between items-center transition-colors ${
                  openIndex === 3 
                    ? 'bg-black text-white' 
                    : 'bg-gray-50 text-gray-900 hover:bg-gray-100'
                }`}
              >
                <span className="font-semibold pr-4 text-sm sm:text-base">Do you provide round-trip cruise terminal transportation?</span>
                <span className="flex-shrink-0">
                  {openIndex === 3 ? (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                  ) : (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  )}
                </span>
              </button>
              {openIndex === 3 && (
                <div className="px-4 sm:px-6 py-3 sm:py-4 bg-white border-t border-gray-200">
                  <p className="text-gray-900 leading-relaxed text-sm sm:text-base">
                    Yes. We offer round-trip cruise port transportation with scheduled return pickups after your cruise.
                  </p>
                </div>
              )}
            </div>

            {/* FAQ 5 */}
            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleFAQ(4)}
                className={`w-full px-4 sm:px-6 py-3 sm:py-4 text-left flex justify-between items-center transition-colors ${
                  openIndex === 4 
                    ? 'bg-black text-white' 
                    : 'bg-gray-50 text-gray-900 hover:bg-gray-100'
                }`}
              >
                <span className="font-semibold pr-4 text-sm sm:text-base">Can you transport large groups to cruise terminals?</span>
                <span className="flex-shrink-0">
                  {openIndex === 4 ? (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                  ) : (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  )}
                </span>
              </button>
              {openIndex === 4 && (
                <div className="px-4 sm:px-6 py-3 sm:py-4 bg-white border-t border-gray-200">
                  <p className="text-gray-900 leading-relaxed text-sm sm:text-base">
                    Absolutely. We provide Sprinter vans and larger vehicles for group cruise transportation.
                  </p>
                </div>
              )}
            </div>

            {/* FAQ 6 - Additional Question */}
            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => toggleFAQ(5)}
                className={`w-full px-4 sm:px-6 py-3 sm:py-4 text-left flex justify-between items-center transition-colors ${
                  openIndex === 5 
                    ? 'bg-black text-white' 
                    : 'bg-gray-50 text-gray-900 hover:bg-gray-100'
                }`}
              >
                <span className="font-semibold pr-4 text-sm sm:text-base">Do you provide luggage assistance?</span>
                <span className="flex-shrink-0">
                  {openIndex === 5 ? (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                  ) : (
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  )}
                </span>
              </button>
              {openIndex === 5 && (
                <div className="px-4 sm:px-6 py-3 sm:py-4 bg-white border-t border-gray-200">
                  <p className="text-gray-900 leading-relaxed text-sm sm:text-base">
                    Yes, our professional chauffeurs will assist with loading and unloading your luggage to ensure a seamless experience.
                  </p>
                </div>
              )}
            </div>
            
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ3;
